import { atom } from 'jotai';

export const $isCreateSupplierDialogOpen = atom<boolean>(false);
export const $createSupplierInitialName = atom<string>('');
export const $onSupplierCreatedCallback = atom<
  ((accountId: string) => void) | null
>(null);

export const $openCreateSupplierDialog = atom(
  null,
  (
    _get,
    set,
    params: {
      onSupplierSelected: (accountId: string) => void;
      initialName?: string;
    },
  ) => {
    set($onSupplierCreatedCallback, params.onSupplierSelected);
    set($createSupplierInitialName, params.initialName ?? '');
    set($isCreateSupplierDialogOpen, true);
  },
);

export const $closeCreateSupplierDialog = atom(null, (_get, set) => {
  set($isCreateSupplierDialogOpen, false);
  set($createSupplierInitialName, '');
  set($onSupplierCreatedCallback, null);
});
